import { LabelMini } from '@liveauctioneers/hammer-ui-core/text';

import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

type LotCardBidLabelProps = {
    bidCount: number;
};

export const LotCardBidLabel = ({ bidCount }: LotCardBidLabelProps) => {
    const formatMessage = useAppFormatMessage();

    return (
        <LabelMini>
            {bidCount > 0
                ? formatMessage(['itemBidding', 'currentBidWithCount'], { values: { bidCount } })
                : formatMessage(['itemBidding', 'startingBid'])}
        </LabelMini>
    );
};
